import { z } from 'zod';
import { projectsProjectIdSchema, projectsProjectSchema, projectsStatusKeySchema, } from './projects-project.contract.js';
export const projectsCloseoutValidatorSlot = 'projects.closeout.validators';
export const projectsCloseoutValidatorContractVersion = 'projects.closeout-validator.v1';
export const projectsCloseoutItemKeySchema = z
    .string()
    .min(1)
    .max(80)
    .regex(/^[a-z][a-z0-9]*(?:_[a-z0-9]+)*$/);
export const projectsCloseoutConfigurationItemSchema = z.strictObject({
    key: projectsCloseoutItemKeySchema,
    label: z.string().trim().min(1).max(200),
    required: z.boolean(),
});
export const projectsCloseoutConfigurationSchema = z
    .strictObject({
    schemaVersion: z.literal(1),
    items: z.array(projectsCloseoutConfigurationItemSchema).min(1).max(50),
})
    .superRefine((value, context) => {
    const keys = value.items.map(({ key }) => key);
    if (new Set(keys).size !== keys.length) {
        context.addIssue({
            code: 'custom',
            path: ['items'],
            message: 'Project closeout item keys must be unique.',
        });
    }
});
export const projectsCloseoutValidatorInputSchema = z.strictObject({
    projectId: projectsProjectIdSchema,
    targetStatus: projectsStatusKeySchema,
    projectRevision: z.number().int().positive(),
});
export const projectsCloseoutValidatorResultSchema = z.strictObject({
    key: z.string().min(3).max(160).regex(/^[a-z][a-z0-9-]*(?:\.[a-z0-9-]+)+$/),
    label: z.string().trim().min(1).max(200),
    ready: z.boolean(),
    message: z.string().trim().min(1).max(500).nullable(),
});
export const projectsCloseoutProviderResultSchema = z.strictObject({
    providerId: z.string().min(3).max(160),
    moduleId: z.string().min(2).max(64),
    result: projectsCloseoutValidatorResultSchema,
});
export const projectsCloseoutProviderFailureSchema = z.strictObject({
    providerId: z.string().min(3).max(160),
    moduleId: z.string().min(2).max(64),
    code: z.literal('validator_unavailable'),
});
export const projectsProjectCloseoutReadinessSchema = z.strictObject({
    projectId: projectsProjectIdSchema,
    currentStatus: projectsStatusKeySchema,
    expectedRevision: z.number().int().positive(),
    targetStatuses: z.array(projectsStatusKeySchema).min(1),
    items: z.array(projectsCloseoutConfigurationItemSchema),
    providerResults: z.array(projectsCloseoutProviderResultSchema),
    providerFailures: z.array(projectsCloseoutProviderFailureSchema),
    canCloseWithoutOverride: z.boolean(),
    overrideAllowed: z.boolean(),
});
export const projectsProjectCloseoutReadinessResponseSchema = z.strictObject({
    data: projectsProjectCloseoutReadinessSchema,
});
export const projectsCloseProjectSchema = z.strictObject({
    expectedRevision: z.number().int().positive(),
    targetStatus: projectsStatusKeySchema,
    confirmedItemKeys: z.array(projectsCloseoutItemKeySchema).max(50).refine((keys) => new Set(keys).size === keys.length, 'Project closeout confirmation keys must be unique.'),
    overrideReason: z.string().trim().min(10).max(1000).nullable().default(null),
});
export const projectsProjectCloseoutRecordSchema = z.strictObject({
    id: z.string().uuid(),
    tenantId: z.string().uuid(),
    projectId: projectsProjectIdSchema,
    fromStatus: projectsStatusKeySchema,
    targetStatus: projectsStatusKeySchema,
    checklist: z.array(projectsCloseoutConfigurationItemSchema.extend({ checked: z.boolean() })),
    providerResults: z.array(projectsCloseoutProviderResultSchema),
    overrideUsed: z.boolean(),
    closedByMembershipId: z.string().uuid(),
    projectRevision: z.number().int().positive(),
    closedAt: z.string().datetime({ offset: true }),
});
export const projectsCloseProjectResponseSchema = z.strictObject({
    data: z.strictObject({
        project: projectsProjectSchema,
        closeout: projectsProjectCloseoutRecordSchema.nullable(),
        alreadyClosed: z.boolean(),
    }),
});
//# sourceMappingURL=projects-project-closeout.contract.js.map